import { PartType } from '../constants/part-type.js';
const SELLABLE_PART_TYPES = new Set([
    PartType.INVENTORY,
    PartType.NON_INVENTORY,
    PartType.SERVICE,
]);
export function isSellablePartType(typeId) {
    const id = typeof typeId === 'string' ? Number(typeId) : typeId;
    return Number.isFinite(id) && SELLABLE_PART_TYPES.has(id);
}
//# sourceMappingURL=is-sellable-part-type.js.map